// extracted by mini-css-extract-plugin
export default {"topmargin":"index_topmargin__uXcHg","headertitle":"index_headertitle__ZBvRn"};